export default __webpack_public_path__ + "static/media/giraffe2.ca5899e7.gif";